// import { needAttention as checkNeedAttention } from "./utils/chatHelpers";

// export default function ChatPreviewItem({ conversation, active, onClick }) {
//     const { personName, lastUpdate, historyChat, agentControl } = conversation;

//     const lastMsg = historyChat?.[historyChat.length - 1];
//     const preview = (lastMsg?.user || lastMsg?.agent || lastMsg?.bot || "")
//         .slice(0, 35) + (lastMsg?.length > 35 ? "…" : "");

//     const warn = checkNeedAttention(historyChat);

//     return (
//         <div
//             onClick={onClick}
//             // className={`px-4 py-3 cursor-pointer border-b hover:bg-base-300 ${active ? "bg-base-300" : "bg-base-200"
//             //     }`}
//             className={`px-4 py-3 cursor-pointer border-b transition
//                  ${active ? "bg-base-300" : "bg-base-200 hover:bg-base-300"}
//                  ${warn && !active ? "ring-2 ring-warning" : ""}`}
//         >
//             <div className="flex items-center justify-between">
//                 <span className="font-semibold">{personName}</span>
//                 <span
//                     className={`badge text-[10px] ${agentControl ? "badge-success" : "badge-secondary"
//                         }`}
//                 >
//                     {agentControl ? "Agente" : "Bot"}
//                 </span>
//             </div>
//             <p className="text-xs text-gray-500 truncate">{preview}</p>
//             <p className="text-[10px] text-gray-400">
//                 {new Date(lastUpdate).toLocaleTimeString()}
//             </p>
//             {warn && (
//                 <span className="badge badge-warning badge-xs ml-1 animate-pulse" />
//             )}
//         </div>
//     );
// }



// ChatPreviewItem.jsx
import { needAttention as checkNeedAttention } from "./utils/chatHelpers";

export default function ChatPreviewItem({ conversation, active, onClick }) {
    const { personName, lastUpdate, historyChat, agentControl } = conversation;

    const warn = checkNeedAttention(historyChat, agentControl);
    const last = historyChat.at(-1);
    const resume = (last?.user || last?.agent || last?.bot || "").slice(0, 28);

    return (
        <div
            onClick={onClick}
            className={`stat px-4 py-3 cursor-pointer transition
                  ${active ? "bg-base-300" : "hover:bg-base-200"}
                  ${warn ? "border-l-4 border-warning" : ""}`}
        >
            <div className="stat-title truncate">{personName}</div>
            <div className="stat-value text-base truncate">{resume}</div>
            <div className="stat-desc text-xs">
                {new Date(lastUpdate).toLocaleTimeString()} ·{" "}
                <span className={agentControl ? "text-success" : "text-secondary"}>
                    {agentControl ? "Agente" : "Bot"}
                </span>
            </div>
        </div>
    );
}
